import script from "./overall-security-status.vue?vue&type=script&lang=ts&setup=true"
export * from "./overall-security-status.vue?vue&type=script&lang=ts&setup=true"

import "./overall-security-status.vue?vue&type=style&index=0&id=fba6f33a&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fba6f33a"]])

export default __exports__